import React from 'react';
import { Button } from './Button';
import { Reveal } from './Reveal';
import { images, candidateShareItems } from '../data/content';
export function CandidateSection() {
  return <section className="bg-mist py-24 lg:py-32" data-id="element-70" data-mp="2h5afts759he3">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-12 lg:gap-12 lg:px-10" data-id="element-71" data-mp="2h3zedz168lq5">
        <Reveal className="relative mx-auto w-full max-w-md lg:col-span-5 lg:max-w-none" data-id="element-72" data-mp="2c67a05jcb752">
          <div className="absolute -left-4 -top-4 hidden h-full w-full border border-gold/70 sm:block" aria-hidden="true" data-id="element-73" data-mp="286gly9l77548" />
          <img src={images.candidate} alt="An experienced professional reviewing notes in a bright office" className="relative aspect-[4/5] w-full object-cover" data-id="element-74" data-mp="1y66aouiq47rp" />
        </Reveal>

        <Reveal delay={0.05} className="lg:col-span-6 lg:col-start-7" data-id="element-75" data-mp="3sjfmwu2nm7dn">
          <p className="text-sm font-medium text-gold-dark" data-id="element-76" data-mp="3nl4e8mo3i2x0">For Candidates</p>
          <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-77" data-mp="3rb7dctjg3wr7">
            Your experience deserves the right opportunity.
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink/75" data-id="element-78" data-mp="67jz8b04nw9">
            We welcome expressions of interest from experienced professionals who would like to be
            considered for relevant senior and leadership opportunities aligned with their
            experience and career goals.
          </p>

          <div className="mt-10 max-w-xl" data-id="element-79" data-mp="ive8jbyh89pz">
            <p className="text-sm font-medium text-ink" data-id="element-80" data-mp="iucle946rwrw">Helpful details to share</p>
            <ul className="mt-3 divide-y divide-ink/10 border-y border-ink/10" data-id="element-81" data-mp="479p25rlnu65">
              {candidateShareItems.map(item => <li key={item} className="flex items-center gap-4 py-3.5 text-[15px] text-ink/75" data-id="element-82" data-mp="9403konrahpg">
                  <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-83" data-mp="wtly2yt6o8r4" />
                  {item}
                </li>)}
            </ul>
          </div>

          <Button to="/candidates#register" variant="navy" className="mt-10" data-id="element-84" data-mp="1bhca79k3nghc">
            Register Your Interest
          </Button>
          <p className="mt-4 max-w-xl text-sm text-ink/60" data-id="element-85" data-mp="16gyemqzopz07">
            Vacancies aren’t listed on this site. Registering interest does not guarantee
            consideration for a specific role.
          </p>
        </Reveal>
      </div>
    </section>;
}